import { motion, AnimatePresence } from 'framer-motion';
import { styled } from '@mui/material/styles';
import type { ZIndex } from '@mui/material';

const OverlayDiv = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: ${(p) => p.theme.zIndex['modal'] - 1};
`;

interface OverlayProps {
  isVisible: boolean;
  onClick?: () => void;
  component?: keyof ZIndex;
}

const Overlay = ({ isVisible, onClick }: OverlayProps) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <OverlayDiv
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.8 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClick}
        />
      )}
    </AnimatePresence>
  );
};

export default Overlay;
